import './loading.css'
import MetaData from '../MetaData.js'

import React from 'react'

const Loading = () => {
  return (
    <div className='loading'>
      <MetaData title="Loading..." />
        <div></div>
    </div>
  )
}

export default Loading